<template lang="">
    <div class="flex flex-wrap w-full justify-center items-center">
       <div class="container mx-auto bg-white">
           <section>
                <div class="flex flex-row justify-between items-end pt-6  pb-4">
                    <div class="w-full flex flex-col justify-around pl-2 ">
                        <h1 class="text-2xl text-gray-800 font-semibold pt-2 pb-2">Список клиентов</h1>

                        <section>
                                <div class="w-full flex flex-row justify-between items-center pt-2 pb-2">
                                    <div class="w-1/2 flex flex-col justify-around pl-2">
                                        <span class="text-base">Показаны {{ meta.from }} - {{ meta.to}} из {{ meta.total}}</span>
                                    </div>
                                    <div v-if="meta.links.length > 3" class="w-1/2 flex flex-row justify-end">
                                        <div v-for="link, index in meta.links" :key="index">
                                            <div
                                                v-if="index != 0 && index != meta.links.length-1"
                                                class="py-2 px-4 bg-gray-100 rounded-md"
                                                :class="[
                                                        meta.current_page == parseInt(link.label) ? 'bg-yellow-300 font-semibold' : '',
                                                        link.url !== null ? 'hover:bg-yellow-300 cursor-pointer' : ''
                                                    ]"
                                                @click="()=>{ if(link.url != null ){ changePage(parseInt(link.label)) }}"
                                                >{{ link.label }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </section>
                    </div>
                </div>
                <div class="w-full rounded-lg border-2 border-gray-100">
                    <div class="items_list">
                        <div class="w-full flex flex-row bg-gray-100">
                            <div class="w-1/12 p-2"></div>
                            <div class="w-5/12 p-2" >ФИО</div>
                            <div class="w-3/12 p-2" >Телефоны</div>
                            <div class="w-2/12 p-2" >Адреса</div>
                            <div class="w-2/12 p-2" >Подарки</div>
                            <div class="w-2/12 p-2" >Заказы</div>
                            <div class="w-3/12 p-2" >Активен</div>
                            <div class="w-1/12 p-2" ></div>
                        </div>
                        <div v-for="item in collection" :key="item.id">
                            <div class="w-full flex flex-row text-sm hover:bg-gray-100" style="border-top: 1px dashed">
                                <div class="w-full flex flex-row hover:bg-gray-100 items-center">
                                    <div class="w-1/12 flex justify-center p-2">
                                        <router-link :to="{name: 'CustomersEdit', params: { id: item.id  }}">
                                            #{{ item.id}}
                                        </router-link>
                                    </div>
                                    <div class="w-5/12 p-2 text-base flex flex-col">
                                        <router-link :to="{name: 'CustomersEdit', params: { id: item.id  }}">
                                            {{ item.first_name }} {{ item.last_name }}
                                            <div v-for="label, index in item.labels" :key="index">{{ label.title }}</div>
                                        </router-link>
                                        <div class=" flex flex-row text-sm text-gray-300">
                                            <!-- | {{ item.phones }} -->
                                            <!-- | {{ item.birthday }}
                                            | {{ item.sex }}
                                            | {{ item.email }} -->
                                        </div>
                                    </div>
                                    <div class="w-3/12 px-2">
                                        <div v-for="phone, index in item.phones" :key="index">
                                            <router-link :to="{ name: 'PhonesEdit', params: { id: phone.id } }">
                                                {{ phone.number }} |
                                                {{ phone.orders_count }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="w-2/12 px-2">{{ item.addresses_count }}</div>
                                    <div class="w-2/12 px-2">{{ item.gifts_count }}</div>
                                    <div class="w-2/12 px-2">
                                        {{ item.orders_count }} :
                                        {{ item.orders_delivered_numb }} |
                                        {{ item.orders_cancelled_numb }} |
                                        {{ item.orders_declined_numb }}
                                    </div>
                                    <div class="w-3/12 px-2">
                                        <!-- {{ item.lastseen_at }} -->
                                        {{ item.latest_delivery_at || '' }}
                                    </div>
                                    <div class="w-1/12 p-2 flex flex-row">
                                        <div v-if="item.addresses_count == 0 && item.phones?.length == 0 && item.gifts_count == 0 && item.orders_count == 0 && !item.lastseen_at ">
                                            <div @click="deleteCustomer(item)" class="w-8 h-8 flex justify-center items-center bg-gray-100 rounded-full cursor-pointer hover:bg-red-100 text-gray-700 font-semibold">x</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           </section>
           <section>
                <div class="flex flex-row justify-between items-center pt-6 pb-24">
                    <div class="w-1/2 flex flex-col justify-around pl-2">
                        <span class="text-base">Показаны {{ meta.from }} - {{ meta.to}} из {{ meta.total}}</span>
                    </div>
                    <div v-if="meta.links.length > 3" class="w-1/2 flex flex-row justify-end">
                        <div v-for="link, index in meta.links" :key="index">
                            <div
                                v-if="index != 0 && index != meta.links.length-1"
                                class="py-2 px-4 bg-gray-100 rounded-md"
                                :class="[
                                        meta.current_page == parseInt(link.label) ? 'bg-yellow-300 font-semibold' : '',
                                        link.url !== null ? 'hover:bg-yellow-300 cursor-pointer' : ''
                                    ]"
                                @click="()=>{ if(link.url != null ){ changePage(parseInt(link.label)) }}"
                                >{{ link.label }}
                            </div>
                        </div>
                    </div>
                </div>
           </section>
       </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            meta: {
                current_page: 0,
                per_page: 25,
                last_page: 0,
                links: [],
                total: 0,
                from: 0,
                to: 0
            },

            collection: []
            // showEditItemDialog: false,
        }
    },
    methods: {
        getCustomers () {
            this.getServerData('customers_list', { per_page: this.meta.per_page, current_page: this.meta.current_page, with: 'labels,phones', with_count: 'orders,addresses,gifts' })
                .then((res) => {
                    this.meta.current_page = res.data.current_page
                    this.meta.per_page = res.data.per_page
                    this.meta.last_page = res.data.last_page
                    this.meta.links = res.data.links
                    this.meta.total = res.data.total
                    this.meta.from = res.data.from
                    this.meta.to = res.data.to
                    this.collection = res.data.data
                })
                .catch(() => {})
        },
        changePage (page) {
            this.$router.push({ name: 'CustomersList', params: { page } })
        },
        deleteCustomer (item) {
            this.postServerData('customer_delete', { data: { customer_id: item.id } }).then(() => {
                this.getCustomers()
            })
            .catch((e) => {})
        }
    },
    mounted () {
        if (this.$route.params.page) {
            this.meta.current_page = this.$route.params.page
        }

        this.getCustomers()
    },
    watch: {
        $route (to, from) {
            if (to.name === 'CustomersList') {
                this.meta.current_page = to.params.page
                this.getCustomers()
            }
        }
    },
    components: {
    }
}
</script>
<style lang="">

</style>
